export default {
  validated:           'Número validado',
  not_validated:       'Validação pendente',
  enter_sms_code:      'Enviamos um SMS para o seu número com um <strong>código de validação.</strong> Insira o código de <strong>4 dígitos</strong> no campo abaixo.',
  validate:            'Validar',
  never_received_code: 'Não recebeu o código?',
  resend_code:         'Reenviar código',
  request_code:        'Solicitar Código',
  cell_phone:          'Telefone Celular',
  cell_paragraph:      'Para validar o seu número, clique no botão <strong>"Solicitar código"</strong> abaixo.',
  cell_label:          'Número do celular com DDD',
  invalid_number:      'Por favor, preencha um número de telefone válido (DDD) + 9 dígitos - (XX) XXXXX-XXXX',
  invalid_code:        'Obrigatório 4 dígitos',
  code_label:          'Código',
};
